import { ReactNode } from "react";
import "@Forge/dist/forge.css";
import { Root } from "@/vendor/Forge/dist";

interface Props {
  children?: ReactNode;
}
/**
 * @description Provider will create wrapper for forge components to properly receive styles. This provider will also bring in the Forge css.
 * */
const ForgeProvider = ({ children }: Props) => (
  // forge requires this classname for styles to be applied.
  <Root>
    <div className="fe_f_all">{children}</div>
  </Root>
);

export default ForgeProvider;
